/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { NftGrouping } from './NftGrouping';
import {
    NftGroupingFromJSON,
    NftGroupingFromJSONTyped,
    NftGroupingToJSON,
    NftGroupingToJSONTyped,
} from './NftGrouping';

/**
 * 
 * @export
 * @interface GetNftGroupingsResponse
 */
export interface GetNftGroupingsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetNftGroupingsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<NftGrouping>}
     * @memberof GetNftGroupingsResponse
     */
    nftGroupings: Array<NftGrouping>;
}

/**
 * Check if a given object implements the GetNftGroupingsResponse interface.
 */
export function instanceOfGetNftGroupingsResponse(value: object): value is GetNftGroupingsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('nftGroupings' in value) || value['nftGroupings'] === undefined) return false;
    return true;
}

export function GetNftGroupingsResponseFromJSON(json: any): GetNftGroupingsResponse {
    return GetNftGroupingsResponseFromJSONTyped(json, false);
}

export function GetNftGroupingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftGroupingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'nftGroupings': ((json['nftGroupings'] as Array<any>).map(NftGroupingFromJSON)),
    };
}

export function GetNftGroupingsResponseToJSON(json: any): GetNftGroupingsResponse {
    return GetNftGroupingsResponseToJSONTyped(json, false);
}

export function GetNftGroupingsResponseToJSONTyped(value?: GetNftGroupingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'nftGroupings': ((value['nftGroupings'] as Array<any>).map(NftGroupingToJSON)),
    };
}

